'use client'

import { useEffect, useState } from 'react'

const SWIPE_THRESHOLD = 50

export function useProductGallery(images: string[]) {
  const [activeImageIndex, setActiveImageIndex] = useState(0)
  const [activeImage, setActiveImage] = useState<string | undefined>(images[0])
  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)

  // Switching variant (e.g. color) swaps the image list; start from its cover
  // instead of keeping an index that may not exist in the new list.
  const imagesKey = (images || []).join('\n')
  const [prevImagesKey, setPrevImagesKey] = useState(imagesKey)
  if (prevImagesKey !== imagesKey) {
    setPrevImagesKey(imagesKey)
    setActiveImageIndex(0)
    setActiveImage(images?.[0])
  }

  useEffect(() => {
    if (images && images.length > 0 && activeImageIndex < images.length) {
      setActiveImage(images[activeImageIndex])
    }
  }, [activeImageIndex, images])

  const swipe = (direction: 'left' | 'right') => {
    if (!images || images.length <= 1) return
    const newIndex = direction === 'left'
      ? (activeImageIndex > 0 ? activeImageIndex - 1 : images.length - 1)
      : (activeImageIndex < images.length - 1 ? activeImageIndex + 1 : 0)
    setActiveImageIndex(newIndex)
    setActiveImage(images[newIndex])
  }

  const selectIndex = (index: number) => {
    setActiveImageIndex(index)
    setActiveImage(images[index])
  }

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX)
  }

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    const distance = touchStart - touchEnd
    if (distance > SWIPE_THRESHOLD && images.length > 1) swipe('right')
    if (distance < -SWIPE_THRESHOLD && images.length > 1) swipe('left')
  }

  return {
    activeImage,
    activeImageIndex,
    swipe,
    selectIndex,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  }
}
